module.exports = __webpack_public_path__ + "img/o2o02.0278ee5c.png";